import { useContext, useState } from "react";
import { SelectedImageContext } from "../../../SelectedImageContext";
import { CameraContext } from "../../../CameraContext";
import { Modal } from "react-bootstrap";
import { WebCamModal } from "../../UserProfile/WebCam/CameraModal";
import ImageModal from "../../UserProfile/WebCam/ImageModal";

interface ModalProps {
    showModal: boolean;
    handleCloseModal: () => void;
    UploadImageToBlobStorage: (file: File) => void;
    isReady?: boolean;
    uploadRequestState: "idle" | "loading" | "success" | "error";
}


const ModalFriendPictureInput: React.FC<ModalProps> = ({
    showModal,
    handleCloseModal,
    UploadImageToBlobStorage,
    isReady = true,
    uploadRequestState,
}) => {

    const { setSelectedFriendImg, selectedFriendImg } = useContext(SelectedImageContext);
    const { isOpen, setOpenCamera } = useContext(CameraContext);
    const [showImgModal, setShowImgModal] = useState<boolean>(false);
    const isUploading = uploadRequestState === "loading";

    const UploadImage = () => {
        if (isUploading) {
            return;
        }

        if (selectedFriendImg) {
            UploadImageToBlobStorage(selectedFriendImg);
        }
    }
    const onFileChanged = (file: File) => {
        if (isUploading) {
            return;
        }

        handleCloseModal();
        setSelectedFriendImg(file);
        setShowImgModal(true);
    };
    const openCameraR = () => {
        if (isUploading) {
            return;
        }

        handleCloseModal();
        setOpenCamera(true);
    }

    return (
        <>
            <Modal
                backdrop={false}
                centered
                show={showModal}
                onHide={() => {
                    if (!isUploading) {
                        handleCloseModal();
                    }
                }}
                keyboard={!isUploading}
            >
                <Modal.Body>
                    Only one person per picture. No text or filters.
                    <div className="mt-3">
                        {/* Add Camera Functionbality Later */}
                        <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2" onClick={openCameraR} disabled={isUploading}>
                            Camera
                        </button>
                        <label
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 "
                            style={{ cursor: "pointer" }}
                        >
                            <input
                                type="file"
                                id="fileInput"
                                style={{ display: "none" }}
                                className="col-12 mt-2"
                                onChange={(e) => e.target.files ? onFileChanged(e.target.files[0]) : undefined}
                            />
                            Gallery
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex  align-content-center  col-12  mb-2"
                        onClick={handleCloseModal}
                        disabled={isUploading}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>

            {isOpen && <WebCamModal setShowCropModal={() => { }} setShowImgModal={setShowImgModal} isFriendProfilePicture={true}/>}

            <ImageModal
                showImgModal={showImgModal}
                handleCloseModal={setShowImgModal}
                setOpenCamera={setOpenCamera}
                UploadImage={UploadImage}
                isReady={isReady}
                uploadRequestState={uploadRequestState}
            />
        </>
    )
}

export default ModalFriendPictureInput
